<template>
  <v-container fluid>
    <Bio :isEdit="false" :title="'Account Information'" :showEdit="true" />
  </v-container>
</template>
<script>
import Bio from "../../../applications/components/bio.vue";
export default {
  name: "AccountInfo",
  components: { Bio },
  data: () => {
    return {};
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Profile/getProfile");
      v.$store.dispatch("Profile/getAllSetup");
    });
  },
};
</script>
<style>
@import url("style.css");
</style>
